import { FcatQueueType, HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '../../models';
import { LocDisplayType } from '../../models/display-type';
import { SYSTEM_ENUM_ROOT, SYSTEM_ENUM_TYPE } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|Fulfillment Catalog Queue Type|`;

type SharedKeys = Pick<
	LocDef,
	'portal' | 'displayType' | 'htmlAllowed' | 'portal' | 'shared' | 'feature'
>;

const sharedLocData: Pick<LocDef, 'displayType' | 'htmlAllowed' | 'shared' | 'feature'> = {
	displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
	htmlAllowed: false,
	shared: true,
	feature: HubFeature.CredentialFulfillment,
};

const sharedSpLocData: SharedKeys = {
	...sharedLocData,
	portal: 'SP',
};

const sharedCpLocData: SharedKeys = {
	...sharedLocData,
	portal: 'CP',
};

export type CPFcatQueueTypeLocs =
	| 'CPFcatQueueTypeEnumEachNewItem'
	| 'CPFcatQueueTypeEnumManual'
	| 'CPFcatQueueTypeEnumNever'
	| 'CPFcatQueueTypeEnumOnce';

export type SPFcatQueueTypeLocs =
	| 'SPFcatQueueTypeEnumEachNewItem'
	| 'SPFcatQueueTypeEnumManual'
	| 'SPFcatQueueTypeEnumNever'
	| 'SPFcatQueueTypeEnumOnce';

export const cpFcatQueueTypeEnumLocs: LocDefs<CPFcatQueueTypeLocs> = {
	CPFcatQueueTypeEnumEachNewItem: {
		defaultValue: 'Each New Credential',
		displayPath: `${dpRoot}Each New Item`,
		description: `System value for 'Each New Item' Fulfillment Catalog queue type`,
		legacyName: 'Credential.Fulfillment/System.Enum.FcatQueueType.EachNewItem',
		...sharedCpLocData,
	},
	CPFcatQueueTypeEnumManual: {
		defaultValue: 'Manual',
		displayPath: `${dpRoot}Manual`,
		description: `System value for 'Manual' Fulfillment Catalog queue type`,
		legacyName: 'Credential.Fulfillment/System.Enum.FcatQueueType.Manual',
		...sharedCpLocData,
	},
	CPFcatQueueTypeEnumNever: {
		defaultValue: 'Never',
		displayPath: `${dpRoot}Never`,
		description: `System value for 'Never' Fulfillment Catalog queue type`,
		legacyName: 'Credential.Fulfillment/System.Enum.FcatQueueType.Never',
		...sharedCpLocData,
	},
	CPFcatQueueTypeEnumOnce: {
		defaultValue: 'First Earned Credential',
		displayPath: `${dpRoot}Once`,
		description: `System value for 'Once' Fulfillment Catalog queue type`,
		legacyName: 'Credential.Fulfillment/System.Enum.FcatQueueType.Once',
		...sharedCpLocData,
	},
};

export const spFcatQueueTypeEnumLocs: LocDefs<SPFcatQueueTypeLocs> = {
	SPFcatQueueTypeEnumEachNewItem: {
		defaultValue: 'Each New Credential',
		displayPath: `${dpRoot}Each New Item`,
		description: `System value for 'Each New Item' Fulfillment Catalog queue type`,
		legacyName: 'Credential.Fulfillment/System.Enum.FcatQueueType.EachNewItem',
		...sharedSpLocData,
	},
	SPFcatQueueTypeEnumManual: {
		defaultValue: 'Manual',
		displayPath: `${dpRoot}Manual`,
		description: `System value for 'Manual' Fulfillment Catalog queue type`,
		legacyName: 'Credential.Fulfillment/System.Enum.FcatQueueType.Manual',
		...sharedSpLocData,
	},
	SPFcatQueueTypeEnumNever: {
		defaultValue: 'Never',
		displayPath: `${dpRoot}Never`,
		description: `System value for 'Never' Fulfillment Catalog queue type`,
		legacyName: 'Credential.Fulfillment/System.Enum.FcatQueueType.Never',
		...sharedSpLocData,
	},
	SPFcatQueueTypeEnumOnce: {
		defaultValue: 'First Earned Credential',
		displayPath: `${dpRoot}Once`,
		description: `System value for 'Once' Fulfillment Catalog queue type`,
		legacyName: 'Credential.Fulfillment/System.Enum.FcatQueueType.Once',
		...sharedSpLocData,
	},
};

export const FCAT_QUEUE_TYPE_ENUM_LOCS = MapLocKeys<CPFcatQueueTypeLocs | SPFcatQueueTypeLocs>({
	...cpFcatQueueTypeEnumLocs,
	...spFcatQueueTypeEnumLocs,
});

export type CPFcatQueueTypeEnumLocType = LocMap<CPFcatQueueTypeLocs>;
export type SPFcatQueueTypeEnumLocType = LocMap<SPFcatQueueTypeLocs>;

export const cpFcatQueueTypeKeys: { [key in FcatQueueType]: keyof CPFcatQueueTypeEnumLocType } = {
	[FcatQueueType.EachNewItem]: FCAT_QUEUE_TYPE_ENUM_LOCS.CPFcatQueueTypeEnumEachNewItem,
	[FcatQueueType.Manual]: FCAT_QUEUE_TYPE_ENUM_LOCS.CPFcatQueueTypeEnumManual,
	[FcatQueueType.Never]: FCAT_QUEUE_TYPE_ENUM_LOCS.CPFcatQueueTypeEnumNever,
	[FcatQueueType.Once]: FCAT_QUEUE_TYPE_ENUM_LOCS.CPFcatQueueTypeEnumOnce,
};

export const spFcatQueueTypeKeys: { [key in FcatQueueType]: keyof SPFcatQueueTypeEnumLocType } = {
	[FcatQueueType.EachNewItem]: FCAT_QUEUE_TYPE_ENUM_LOCS.SPFcatQueueTypeEnumEachNewItem,
	[FcatQueueType.Manual]: FCAT_QUEUE_TYPE_ENUM_LOCS.SPFcatQueueTypeEnumManual,
	[FcatQueueType.Never]: FCAT_QUEUE_TYPE_ENUM_LOCS.SPFcatQueueTypeEnumNever,
	[FcatQueueType.Once]: FCAT_QUEUE_TYPE_ENUM_LOCS.SPFcatQueueTypeEnumOnce,
};
